const sprintf = require('sprintf-js').sprintf;

module.exports = function(float) {
  if (float === '') {
    return '---';
  } else if (isNaN(float)) {
    return '---';
  } else {
    return sprintf('%4.2f', float);
  }
}





// WEBPACK FOOTER //
// ./src/utilities/fixGPAFloat.js